export const SET_SEARCH_STATE = "SET_SEARCH_STATE"
export const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS"
